// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.AboutHero_hero__kON\\+a {
  position: relative;
  width: 100%;
  height: 600px; /* ✅ ֆիքսված բարձրություն */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.AboutHero_hero__kON\\+a .AboutHero_heroImg__U9jo3 {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.AboutHero_hero__kON\\+a .AboutHero_overlay__VLUGf {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 30, 84, 0.45);
}
.AboutHero_hero__kON\\+a .AboutHero_content__6789n {
  position: relative;
  z-index: 2;
  color: #fff;
  max-width: 650px;
  margin-left: 80px;
}
.AboutHero_hero__kON\\+a .AboutHero_content__6789n h1 {
  font-size: 2.8rem;
  font-weight: 700;
  line-height: 1.3;
}
.AboutHero_hero__kON\\+a {
  /* 🔹 Փոքր էկրանների համար */
}
@media (max-width: 992px) {
  .AboutHero_hero__kON\\+a {
    height: 500px;
  }
  .AboutHero_hero__kON\\+a .AboutHero_content__6789n {
    margin-left: 40px;
  }
  .AboutHero_hero__kON\\+a .AboutHero_content__6789n h1 {
    font-size: 2.2rem;
  }
}
@media (max-width: 768px) {
  .AboutHero_hero__kON\\+a {
    height: 400px;
    justify-content: center;
    text-align: center;
  }
  .AboutHero_hero__kON\\+a .AboutHero_content__6789n {
    margin-left: 0;
    padding: 0 20px;
  }
  .AboutHero_hero__kON\\+a .AboutHero_content__6789n h1 {
    font-size: 1.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleAboutUs/AboutHero.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,WAAA;EACA,aAAA,EAAA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAEF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAEJ;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;AACJ;AAEE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAN;AAlCA;EAsCE,4BAAA;AADF;AAEE;EAvCF;IAwCI,aAAA;EACF;EACE;IACE,iBAAA;EACJ;EAAI;IACE,iBAAA;EAEN;AACF;AAEE;EAlDF;IAmDI,aAAA;IACA,uBAAA;IACA,kBAAA;EACF;EACE;IACE,cAAA;IACA,eAAA;EACJ;EACI;IACE,iBAAA;EACN;AACF","sourcesContent":[".hero {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 600px; /* ✅ ֆիքսված բարձրություն */\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n\r\n  .heroImg {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center;\r\n  }\r\n\r\n  .overlay {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 30, 84, 0.45);\r\n  }\r\n\r\n  .content {\r\n    position: relative;\r\n    z-index: 2;\r\n    color: #fff;\r\n    max-width: 650px;\r\n    margin-left: 80px;\r\n\r\n    h1 {\r\n      font-size: 2.8rem;\r\n      font-weight: 700;\r\n      line-height: 1.3;\r\n    }\r\n  }\r\n\r\n  /* 🔹 Փոքր էկրանների համար */\r\n  @media (max-width: 992px) {\r\n    height: 500px;\r\n\r\n    .content {\r\n      margin-left: 40px;\r\n      h1 {\r\n        font-size: 2.2rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    height: 400px;\r\n    justify-content: center;\r\n    text-align: center;\r\n\r\n    .content {\r\n      margin-left: 0;\r\n      padding: 0 20px;\r\n\r\n      h1 {\r\n        font-size: 1.8rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `AboutHero_hero__kON+a`,
	"heroImg": `AboutHero_heroImg__U9jo3`,
	"overlay": `AboutHero_overlay__VLUGf`,
	"content": `AboutHero_content__6789n`
};
export default ___CSS_LOADER_EXPORT___;
